import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  add_row_change_approvers,
  add_row_change_approvers_success,
  add_row_change_approvers_failure,
  get_approvers_documents_by_approvers,
  get_approvers_documents_by_approvers_success,
  get_approvers_documents_by_approvers_failure,
  update_approvers_documents_by_approvers,
  update_approvers_documents_by_approvers_success,
  update_approvers_documents_by_approvers_failure,
} from "./actions";
import {
  approversDependenciesListName,
  myDocumentsListName,
  versionsByDocumentListName,
  approversCardDocumentListName,
  historyByDocumentListName,
  historyChangeFieldsDocumentListName,
  siteUrl,
  emailsSender,
  usersListName,
} from "src/api/config/config";
import {
  deleteItemRequest,
  updateItemRequest,
  getItemsRequest,
  addItemRequest,
  setStrapiItemUserFieldsById,
} from "../spItems/api";
import { ListFieldsKeys } from "src/api/config";
import { remove_row_change_approvers, remove_row_change_approvers_success, remove_row_change_approvers_failure } from "./actions";
import { update_row_change_approvers, update_row_change_approvers_success, update_row_change_approvers_failure } from "./actions";
import { notificationsListName } from "src/api/config/notifications.config";
import { emailQueueListName } from "src/api/config/email.config";
import { docStatuses } from "src/api/config/systemSwitch";
import { selectUsers } from "src/modules/users/selector";
import moment from "moment";
import { notificationStatuses } from "src/api/config/systemSwitch";
import { prefix, removePrefix } from "src/utils/users.utils";

const SYSTEM_EMAIL = 'supply.portal@abinbevefes.com';
const SYSTEM_EMAIL_ID = 15778;
const is_prod_mode = true;

const getApproverId = (approver: any): number | undefined => {
  const candidates = [approver?.value?.Id, approver?.value?.id, approver?.Id, approver?.id];
  for (const candidate of candidates) {
    if (candidate === undefined || candidate === null || candidate === '') {
      continue;
    }
    if (typeof candidate === 'string' && candidate.includes('@')) {
      continue;
    }
    const id = Number(candidate);
    if (Number.isFinite(id) && id > 0) {
      return id;
    }
  }
  return undefined;
};

const getApproverEmail = (approver: any): string => {
  const raw =
    approver?.value?.Email ||
    approver?.value?.EmailAddress ||
    approver?.value?.email ||
    approver?.value?.WorkEmail ||
    approver?.Email ||
    approver?.email ||
    approver?.Metadata?.Email ||
    approver?.Metadata?.email ||
    '';
  if (raw) {
    return removePrefix(String(raw), prefix).toLowerCase().trim();
  }
  const accountName = approver?.value?.AccountName || approver?.AccountName;
  if (accountName) {
    return removePrefix(String(accountName), prefix).toLowerCase().trim();
  }
  if (typeof approver?.id === 'string' && approver.id.includes('@')) {
    return removePrefix(approver.id, prefix).toLowerCase().trim();
  }
  return '';
};

function* resolveApproverNumericId(approver: any): Generator {
  const direct = getApproverId(approver);
  if (direct) {
    return direct;
  }

  const email = getApproverEmail(approver);
  if (!email) {
    return undefined;
  }

  const usersItems: any = yield select((state: any) => state.users?.items);
  const fromStore = usersItems?.[email] || usersItems?.[email.toLowerCase()];
  const storeId = fromStore?.Id || fromStore?.id;
  if (storeId && Number(storeId) > 0) {
    return Number(storeId);
  }

  try {
    const response: any = yield call<any>(getItemsRequest, {
      listName: usersListName,
      rowLimit: 1,
      filters: {
        Email: email,
      },
    });
    const item = response?.items?.[0];
    const itemEmail = String(item?.Email || item?.email || '').toLowerCase().trim();
    if (itemEmail && itemEmail === email) {
      const id = item?.ID || item?.id || item?.UserID;
      if (id && Number(id) > 0) {
        return Number(id);
      }
    }
  } catch (error) {
    console.log('resolveApproverNumericId error', error);
  }

  return undefined;
}

function* addItemWithSystemAuthor(
  listName: ListFieldsKeys,
  body: Record<string, any>,
  userFields: Record<string, number> = { Author: SYSTEM_EMAIL_ID },
): Generator {
  const itemBody = { ...body };
  Object.keys(userFields).forEach((key) => {
    delete itemBody[key];
  });

  const itemId: number = yield call<any>(addItemRequest, {
    listName,
    body: itemBody,
  });

  yield call(setStrapiItemUserFieldsById, listName, itemId, userFields);
}

// --- Общие хелперы ---

function* rejectDocumentCards(cards: any[], isVersion: boolean): Generator {
  for (const card of cards) {
    console.log('card', card);
    const cardId = card.ID;
    const mainDocId = isVersion && card.MainDocument ? card.MainDocument.get_lookupId() : cardId;
    // const mainDocId = cardId;

    // Шаг 2: Получение и удаление элементов из MDNotifications
    const notifFilters: any = isVersion
      ? { Document: mainDocId, VersionDocument: cardId }
      : { Document: cardId };
    const notifications: any = yield call<any>(getItemsRequest, {
      listName: notificationsListName,
      filters: notifFilters,
    });
    if (notifications?.items?.length > 0) {
      console.log('step-2', {
        listName: notificationsListName,
        ID: 0,
        Ids: notifications.items.map((n: any) => ({ ID: n.ID })),
      })
      if(is_prod_mode){
        yield call<any>(deleteItemRequest, {
          listName: notificationsListName,
          ID: 0,
          Ids: notifications.items.map((n: any) => ({ ID: n.ID })),
        });
      }
    }

    // Шаг 3: Очистка SP Queued email по CheckDoc
    // const checkDocId = isVersion ? String(mainDocId) : String(cardId);
    const checkDocId = String(cardId);
    const emailItems: any = yield call<any>(getItemsRequest, {
      listName: emailQueueListName,
      filters: { CheckDoc: checkDocId },
    });
    if (emailItems?.items?.length > 0) {
      console.log('step-3', {
        listName: emailQueueListName,
        ID: 0,
        Ids: emailItems.items.map((e: any) => ({ ID: e.ID })),
      })
      if(is_prod_mode){
        yield call<any>(deleteItemRequest, {
          listName: emailQueueListName,
          ID: 0,
          Ids: emailItems.items.map((e: any) => ({ ID: e.ID })),
        });
      }
    }

    // Шаг 4: Обновление MDApproversDocument — замена статуса 11 на 4, заполнение Denied
    
    const approversItems: any = yield call<any>(getItemsRequest, {
      listName: approversCardDocumentListName,
      filters: {
        Document: cardId,
        VersionDocument: isVersion,
        // Queue: true,
        Statuses: [docStatuses.waitApproval],
      },
    });
    console.log('approversItems', approversItems, {
      Document: cardId,
      VersionDocument: isVersion,
      Queue: false,
      Statuses: [docStatuses.waitApproval],
    });

    let approversList: any[] = [];
    let approversGroup: any = null;

    if (approversItems?.items?.length > 0) {
      const approversUpdateArr = approversItems.items.map((a: any) => ({
        ID: a.ID,
        Statuses: [docStatuses.cancel],
        Denied: SYSTEM_EMAIL,
        // Queue: false,
      }));
      approversItems.items.forEach((a: any) => {
        if(a.Approvers && a.Approvers.length > 0) {
          a.Approvers.map((approver: any) => {
            console.log('approver-1', {
              approver,
              email: approver.get_email()
            });
            approversList.push(approver.get_email());
          })
        }
        if(a.Group && a.Group.get_lookupId && a.Group.get_lookupId()) {
          approversGroup = a.Group.get_lookupId();
        }
      });
      console.log('step-4', {
        approversItems,
        listName: approversCardDocumentListName,
        ID: 0,
        Ids: approversItems.items.map((a: any) => ({ ID: a.ID })),
        approversUpdateArr
      })
      if(is_prod_mode){
        yield call<any>(updateItemRequest, {
          listName: approversCardDocumentListName,
          body: { ID: 0 },
          bodyArr: approversUpdateArr,
        });
      }
    }

    // Шаг 5: Удаление записей из MDHistory с Statuses = 11
    const historyItems: any = yield call<any>(getItemsRequest, {
      listName: historyByDocumentListName,
      filters: {
        // DocumentID: mainDocId,
        DocumentID: cardId,
        VersionDocument: isVersion,
        Statuses: [docStatuses.waitApproval],
      },
    });
    if (historyItems?.items?.length > 0) {
      console.log('step-5', {
        listName: historyByDocumentListName,
        ID: 0,
        Ids: historyItems.items.map((h: any) => ({ ID: h.ID })),
      })
      if(is_prod_mode){
        yield call<any>(deleteItemRequest, {
          listName: historyByDocumentListName,
          ID: 0,
          Ids: historyItems.items.map((h: any) => ({ ID: h.ID })),
        });
      }
    }

    // Шаг 6: Создание записей в MDHistory и MDHistoryChangeFields со статусом 4
    console.log('step-6', {
      listName: historyByDocumentListName,
      body: {
        Title: `History card # ${cardId}`,
        // DocumentID: mainDocId,
        DocumentID: cardId,
        ChangeDate: new Date(),
        Denied: SYSTEM_EMAIL,
        Comment: "Отклонено в связи с изменением цепочек согласования",
        Statuses: [docStatuses.cancel],
        VersionDocument: isVersion,
        ApprovalGroup: approversGroup,
        Approvers: approversList,
      },
    })

    if(is_prod_mode){
      yield call<any>(addItemWithSystemAuthor, historyByDocumentListName, {
        Title: `History card # ${cardId}`,
        // DocumentID: mainDocId,
        DocumentID: cardId,
        ChangeDate: new Date(),
        Comment: "Отклонено в связи с изменением цепочек согласования",
        Statuses: [docStatuses.cancel],
        VersionDocument: isVersion,
        ApprovalGroup: approversGroup,
        Approvers: approversList,
      }, { Author: SYSTEM_EMAIL_ID, Denied: SYSTEM_EMAIL_ID });
    }
    console.log('step-6-2', {
      listName: historyChangeFieldsDocumentListName,
      body: {
        Title: `History fields card # ${cardId}`,
        // DocumentID: mainDocId,
        DocumentID: cardId,
        ChangeDate: new Date(),
        Statuses: [docStatuses.cancel],
        VersionDocument: isVersion,
      },
    })
    if(is_prod_mode){
      yield call<any>(addItemWithSystemAuthor, historyChangeFieldsDocumentListName, {
        Title: `History fields card # ${cardId}`,
        // DocumentID: mainDocId,
        DocumentID: cardId,
        ChangeDate: new Date(),
        Statuses: [docStatuses.cancel],
        VersionDocument: isVersion,
        Comment: "Отклонено в связи с изменением цепочек согласования",
      });
    }

    // Шаг 7: Обновление CardStatus = 4 в MDDocuments или MDVersions
    // if(approversList.length > 0){
      console.log('step-7', {
        listName: isVersion ? versionsByDocumentListName : myDocumentsListName,
        body: {
          ID: cardId,
          Status: docStatuses.cancel,
        },
      })
      if(is_prod_mode){
        yield call<any>(updateItemRequest, {
          listName: isVersion ? versionsByDocumentListName : myDocumentsListName,
          body: { ID: 0 },
          bodyArr: [
            {
                ID: cardId,
                Status: docStatuses.cancel,
            }],
        });
      }
    // }

    // Шаг 8: Формирование письма и добавление в SP Queued email
    if (emailsSender && card.AuthorEmail) {
      const timestamp = moment().unix();
      const authorEmail = (typeof card.AuthorEmail === 'string' ? card.AuthorEmail : card.AuthorEmail[0] || '').toLowerCase();
      const users: any = yield select(selectUsers);
      const authorName = users[authorEmail]?.displayName || '';
      const docCardId = cardId;
      const versionParam = isVersion ? `&version=${cardId}` : '';
      const cardLink = `${siteUrl}/dashboard/1?documentCard=${docCardId}${versionParam}`;

      console.log('step-8', {
        listName: emailQueueListName,
        body: {
          Body: `Здравствуйте ${authorName},<br/><br/>
            Уведомляем Вас, что следующий документ был отклонен<br/><br/><a href="${cardLink}">${card.Title}</a><br/><br/>
            <b>Комментарий от администратора: отклонено в связи с изменением матрицы согласования</b>`,
          DateToBeSentAt: moment().subtract(12, 'hours').toDate(),
          Title: 'Мои Документы | Отклонение документа',
          Subject: 'Мои Документы | Отклонение документа',
          Recepients: authorEmail,
          CheckDoc: String(timestamp),
        },
      })
      if(is_prod_mode){
        yield call<any>(addItemRequest, {
          listName: emailQueueListName,
          body: {
            Body: `Здравствуйте ${authorName},<br/><br/>
            Уведомляем Вас, что следующий документ был отклонен<br/><br/>
            <a href="${cardLink}">${card.Title}</a><br/><br/>
            <b>Комментарий от администратора: отклонено в связи с изменением матрицы согласования</b>`,
            DateToBeSentAt: moment().subtract(12, 'hours').toDate(),
            Title: 'Мои Документы | Отклонение документа',
            Subject: 'Мои Документы | Отклонение документа',
            Recepients: authorEmail,
            CheckDoc: String(timestamp),
          },
        });
      }
    }
  }
}

function* fetchAndRejectApprovalDocuments(collectionId: any, docTypeId: any): Generator {
  const documents: any = yield call<any>(getItemsRequest, {
    listName: myDocumentsListName,
    filters: {
      Status: 5,
      Collection: [collectionId],
      DocType: [docTypeId],
    },
  });

  const versions: any = yield call<any>(getItemsRequest, {
    listName: versionsByDocumentListName,
    filters: {
      Status: 5,
      Collection: [collectionId],
      DocType: [docTypeId],
    },
  });

  console.log('documents', documents);
  console.log('versions', versions);

  if (documents?.items?.length > 0) {
    yield call(rejectDocumentCards, documents.items, false);
  }
  if (versions?.items?.length > 0) {
    yield call(rejectDocumentCards, versions.items, true);
  }
}

// --- Общие хелперы ---

function* rejectDocumentCardsApprovers(cards: any[], isVersion: boolean, approversNew: any[], approversOld: any[], groupId: any): Generator {
  const oldApproverId = (yield call(resolveApproverNumericId, approversOld?.[0])) as number | undefined;
  const newApproverId = (yield call(resolveApproverNumericId, approversNew?.[0])) as number | undefined;
  const oldApproverEmail = getApproverEmail(approversOld?.[0]);
  const newApproverEmail = getApproverEmail(approversNew?.[0]);

  console.log('approversNew', approversNew);
  console.log('approversOld', approversOld);
  console.log('groupId', groupId);
  console.log('cards', cards);
  console.log('isVersion', isVersion);
  console.log('resolvedApprovers', { oldApproverId, newApproverId, oldApproverEmail, newApproverEmail });

  if (!oldApproverId) {
    console.log('rejectDocumentCardsApprovers skip: missing old approver id', approversOld);
    return;
  }

  for (const card of cards) {
    console.log('card', {
      ID: card.ID,
      MainDocument: card.MainDocument,
      MainDocumentID: card.MainDocument ? card.MainDocument.get_lookupId() : null,
    })
    const mainDocId = card.ID;
    const cardId = isVersion && card.MainDocument ? card.MainDocument.get_lookupId() : mainDocId;
    // const cardId = mainDocId;

    // ШАГ 1 Обновление списка MDApproversDocument и сбор данных
    const approversItems: any = yield call<any>(getItemsRequest, {
      listName: approversCardDocumentListName,
      filters: {
        Document: mainDocId,
        VersionDocument: isVersion,
        // Queue: false,
        Statuses: [docStatuses.waitApproval],
        Approvers: [oldApproverId],
        Group: groupId,
      },
    });
    console.log('approversItems', approversItems, {
      Document: mainDocId,
      VersionDocument: isVersion,
      Queue: false,
      Statuses: [docStatuses.waitApproval],
      Approvers: [oldApproverId],
      Group: groupId,
    });
    let approversList: any[] = [];
    let approversGroup: any = null;
    if (approversItems?.items?.length > 0) {
      approversItems.items.forEach((a: any) => {
        if(a.Approvers && a.Approvers.length > 0) {
          a.Approvers.map((approver: any) => {
            console.log('approver-2', {
              approver,
              email: approver.get_email(),
              approversNew: approversNew[0],
              approversOld: approversOld[0]
            });
          });
          approversList = a.Approvers.map((approver: any) => (approver.get_lookupId() == oldApproverId && newApproverEmail || approver.get_email()))
        }
        if(a.Group && a.Group.get_lookupId && a.Group.get_lookupId()) {
          approversGroup = a.Group.get_lookupId();
        }
      });

      approversItems.items.map((a: any) => {
        a.Approvers.map((approver: any) => {
          console.log('approver-3', {
            approver,
            email: approver.get_email(),
            approversNew: approversNew[0],
            approversOld: approversOld[0]
          });
        });
      });

      const approversUpdateArr = approversItems.items.map((a: any) => ({
        ID: a.ID,
        Approvers: a.Approvers.map((approver: any) => (approver.get_lookupId() == oldApproverId && newApproverEmail || approver.get_email())),
        // Queue: false,
      }));
      console.log('step-1-approversUpdateArr', {
        listName: approversCardDocumentListName,
        body: { ID: 0 },
        bodyArr: approversUpdateArr,
      })
      if(is_prod_mode){
        yield call<any>(updateItemRequest, {
          listName: approversCardDocumentListName,
          body: { ID: 0 },
          bodyArr: approversUpdateArr,
        });
      }
    }

    // ШАГ 2 Обновление списка MDHistory
    const historyItems: any = yield call<any>(getItemsRequest, {
      listName: historyByDocumentListName,
      filters: {
        DocumentID: mainDocId,
        VersionDocument: isVersion,
        Statuses: [docStatuses.waitApproval],
        Approvers: [oldApproverId],
        ApprovalGroup: groupId,
      },
    });
    console.log('step-2-historyItems', historyItems, {
      DocumentID: mainDocId,
      VersionDocument: isVersion,
      Statuses: [docStatuses.waitApproval],
      Approvers: [oldApproverId],
        ApprovalGroup: groupId,
    });
    if (historyItems?.items?.length > 0) {
      const historyUpdateArr = historyItems.items.map((h: any) => ({
        ID: h.ID,
        Approvers: approversList,
        ApprovalGroup: approversGroup,
        // Approvers: h.Approvers && h.Approvers.length > 0 && h.Approvers.map((approver: any) => (approver.get_lookupId() == approversOld[0].value.Id && approversNew[0].value.Email || approver.get_email())),
        // ApprovalGroup: h.Group && h.Group.get_lookupId(),
      }));
      console.log('step-2-historyUpdateArr', {
        listName: historyByDocumentListName,
        body: { ID: 0 },
        bodyArr: historyUpdateArr,
      })
      if(is_prod_mode){
        yield call<any>(updateItemRequest, {
          listName: historyByDocumentListName,
          body: { ID: 0 },
          bodyArr: historyUpdateArr,
        });
      }
    }

    // ШАГ 3 Обновление списка MDNotifications
    const notifications: any = yield call<any>(getItemsRequest, {
      listName: notificationsListName,
      filters: {
        NotificationType: notificationStatuses.approval,
        EmployeeEmail: oldApproverEmail,
      },
    });
    if (notifications?.items?.length > 0) {
      console.log('step-3-notifications', notifications);
      let notificationsUpdateArr = notifications.items.map((n: any) => ({
        ID: n.ID,
        EmployeeEmail: newApproverEmail,
        Employee: newApproverEmail,
      }));
      console.log('step-3-notificationsUpdateArr', {
        listName: notificationsListName,
        body: { ID: 0 },
        bodyArr: notificationsUpdateArr,
      })
      if(is_prod_mode){
        yield call<any>(updateItemRequest, {
          listName: notificationsListName,
          body: { ID: 0 },
          bodyArr: notificationsUpdateArr,
        });
      }
    }

    // Шаг 4 Обновление очереди писем SP Queued email
    const emailItems: any = yield call<any>(getItemsRequest, {
      listName: emailQueueListName,
      filters: {
        Title: 'Мои Документы | Согласование документа',
        Recepients: oldApproverEmail,
      },
    });
    if (emailItems?.items?.length > 0) {
      const getAbiPersonnelNumber = (value: any) =>
        value?.UserProfileProperties?.find((p: any) => p.Key === 'abiPersonnelNumber')?.Value ?? '';

      const getPreferredNameRus = (value: any) => {
        const displayName = value?.DisplayName || value?.Name || '';
        const parts = displayName.split(' ');
        if (parts.length >= 2) {
          return `${parts[0]} ${parts[1]}`;
        }
        return displayName;
      };

      const oldApproverLabel = `${getPreferredNameRus(approversOld[0].value)} (${getAbiPersonnelNumber(approversOld[0].value)})`;
      const newApproverLabel = `${getPreferredNameRus(approversNew[0].value)} (${getAbiPersonnelNumber(approversNew[0].value)})`;

      let emailUpdateArr = emailItems.items.map((e: any) => ({
        ID: e.ID,
        Recepients: e.Recepients.replace(oldApproverEmail, newApproverEmail),
        Body: e.Body.replace(oldApproverLabel, newApproverLabel),
        IsSent: false
      }));
      console.log('step-4-emailUpdateArr', {
        listName: emailQueueListName,
        body: { ID: 0 },
        bodyArr: emailUpdateArr,
      })
    }

    // Шаг 5 Добавление записей в список MDHistoryChangeFields
    if(approversList.length > 0){
      console.log('step-6', {
        listName: historyChangeFieldsDocumentListName,
        body: {
          Title: `History fields card # ${mainDocId}`,
          DocumentID: mainDocId,
          ChangeDate: new Date(),
          JSONChangesFields: JSON.stringify({
            ApproverChange: {
              old: approversOld.map((a: any) => getApproverEmail(a)),
              new: approversNew.map((a: any) => getApproverEmail(a)),
            },
          }),
          Statuses: [docStatuses.edited],
          VersionDocument: isVersion,
          // Approvers: approversList,
        },
      })
    }

    if(is_prod_mode && approversList.length > 0){
      yield call<any>(addItemWithSystemAuthor, historyChangeFieldsDocumentListName, {
        Title: `History fields card # ${mainDocId}`,
        DocumentID: mainDocId,
        ChangeDate: new Date(),
        JSONChangesFields: JSON.stringify({
          ApproverChange: {
            old: approversOld.map((a: any) => getApproverEmail(a)),
            new: approversNew.map((a: any) => getApproverEmail(a)),
          },
        }),
        Statuses: [docStatuses.edited],
        VersionDocument: isVersion,
        Comment: "Изменен в связи с изменением цепочек согласования",
      });
    }
    
  }
}

function* fetchAndRejectApprovalDocumentsApprovers(collectionId: any, docTypeId: any, approversNew: any[], approversOld: any[], groupId: any): Generator {
  const documents: any = yield call<any>(getItemsRequest, {
    listName: myDocumentsListName,
    filters: {
      Status: 5,
      Collection: [collectionId],
      DocType: [docTypeId],
    },
  });

  const versions: any = yield call<any>(getItemsRequest, {
    listName: versionsByDocumentListName,
    filters: {
      Status: 5,
      Collection: [collectionId],
      DocType: [docTypeId],
    },
  });

  console.log('documents', documents);
  console.log('versions', versions);

  if (documents?.items?.length > 0) {
    yield call(rejectDocumentCardsApprovers, documents.items, false, approversNew, approversOld, groupId);
  }
  if (versions?.items?.length > 0) {
    yield call(rejectDocumentCardsApprovers, versions.items, true, approversNew, approversOld, groupId);
  }
}

// --- Воркеры ---

function* update_approvers_documents_by_approvers_worker({ payload }: ReturnType<typeof update_approvers_documents_by_approvers>): Generator {
  try {
    console.log('update_approvers_documents_by_approvers', payload);

    const oldApprover = payload.approversOld?.[0];
    const newApprover = payload.approversNew?.[0];
    const oldApproverId = (yield call(resolveApproverNumericId, oldApprover)) as number | undefined;
    const newApproverId = (yield call(resolveApproverNumericId, newApprover)) as number | undefined;

    if (!oldApproverId || !newApprover) {
      yield put(update_approvers_documents_by_approvers_failure('Не удалось определить согласованта'));
      return;
    }

    yield call(fetchAndRejectApprovalDocumentsApprovers, payload.item.Collection.id, payload.item.DocumentType.id, [
      {
        ...newApprover,
        value: {
          ...newApprover?.value,
          Id: newApproverId || getApproverId(newApprover),
          Email: getApproverEmail(newApprover),
        },
      },
    ], [
      {
        ...oldApprover,
        value: {
          ...oldApprover?.value,
          Id: oldApproverId,
          Email: getApproverEmail(oldApprover),
        },
      },
    ], payload.item.Group.id);

    yield put(update_approvers_documents_by_approvers_success());
  } catch (error) {
    console.log('update_approvers_documents_by_approvers error', error);
    yield put(update_approvers_documents_by_approvers_failure(error as string));
  }
}

function* get_approvers_documents_by_approvers_worker({ payload }: ReturnType<typeof get_approvers_documents_by_approvers>): Generator {
  try {
    console.log('get_approvers_documents_by_approvers', payload);
    let approver_id = (yield call(resolveApproverNumericId, payload.approvers)) as number | undefined;
    console.log('approver_id', approver_id);
    if (!approver_id) {
      yield put(get_approvers_documents_by_approvers_success(false));
      return;
    }
    let documents: any = yield call<any>(getItemsRequest, {
      listName: approversCardDocumentListName,
      rowLimit: 1,
      filters: {
        Approvers: [approver_id],
        Statuses: [docStatuses.waitApproval],
      },
    });    
    console.log('documents', documents);
    yield put(get_approvers_documents_by_approvers_success(documents && documents.count > 0 ? true : false));
  } catch (error) {
    console.log('get_approvers_documents_by_approvers error', error);
    yield put(get_approvers_documents_by_approvers_failure(error as string));
  }
}

function* update_row_change_approvers_worker({ payload }: ReturnType<typeof update_row_change_approvers>): Generator {
  try {
    let data_update: any = { ID: payload.item.ID };
    let is_state_change = false;

    console.log('update_row_change_approvers_worker', payload);

    if(payload.formValues.Index !== payload.item.Index){
      data_update = {
        ...data_update,
        Order: parseInt(payload.formValues.Index)
      }
      // }
      is_state_change = true;

      yield call(fetchAndRejectApprovalDocuments, payload.item.Collection.id, payload.item.DocumentType.id);
    }

    console.log('update_row_change_approvers_worker', data_update);

    const getApproverMatchKey = (approver: any) => {
      const email = getApproverEmail(approver).toLowerCase();
      if (email) {
        return email;
      }
      return approver?.id != null ? String(approver.id) : "";
    };

    const itemApprovers = payload.item.Approvers || [];
    const itemUsers = payload.item.Users && payload.item.Users.length > 0 ? payload.item.Users.map((a: any) => getApproverEmail(a)).filter(Boolean) : [];
    const itemDefaultApprovers = payload.item.DefaultApprovers && payload.item.DefaultApprovers.length > 0 ? payload.item.DefaultApprovers.map((a: any) => getApproverEmail(a)).filter(Boolean) : [];
    const formApprovers = payload.formValues.Approvers || [];

    const itemApproverIds = new Set(itemApprovers.map(getApproverMatchKey).filter(Boolean));
    const formApproverIds = new Set(formApprovers.map(getApproverMatchKey).filter(Boolean));

    const removedApprovers = itemApprovers.filter((a: any) => !formApproverIds.has(getApproverMatchKey(a)));
    const newApprovers = formApprovers.filter((a: any) => !itemApproverIds.has(getApproverMatchKey(a)));

    if (removedApprovers.length > 0 || newApprovers.length > 0) {
      let approvers_ids = formApprovers.map((approver: any) => getApproverEmail(approver)).filter(Boolean);
      data_update = {
        ...data_update,
        [payload.item.NotChange == '2' ? 'DefaultApprovers' : 'Users']: approvers_ids
      }

      is_state_change = true;
      
    }
    if (removedApprovers.length > 0) {
      console.log('Изменённые согласованты (убраны):', removedApprovers.map((a: any) => ({ id: a.id, name: a.name })));
    }

    console.log('update_row_change_approvers_worker', data_update);

    if (newApprovers.length > 0) {
      console.log('Новые согласованты:', newApprovers.map((a: any) => ({ id: a.value.Id && a.value.Id || a.id, name: a.name })));
      let approvers_ids_new = newApprovers.map((a: any) => getApproverEmail(a)).filter(Boolean);

      if(payload.item.NotChange == '2'){
        approvers_ids_new = approvers_ids_new.filter((a: any) => !itemUsers.includes(a));
        data_update = {
          ...data_update,
          'Users': [
            ...itemUsers,
            ...approvers_ids_new
          ]
        }
      } else {
        approvers_ids_new = approvers_ids_new.filter((a: any) => !itemDefaultApprovers.includes(a));
        data_update = {
          ...data_update,
          'DefaultApprovers': [
            ...itemDefaultApprovers,
            ...approvers_ids_new
          ]
        }
      }
    }

    is_state_change = true;

    console.log('update_row_change_approvers_worker', data_update);

    data_update = {
      ...data_update,
      Users: formApprovers.map((a: any) => getApproverEmail(a)).filter(Boolean)
    }

    if(is_state_change){

      console.log('update_row_change_approvers_worker', data_update);

      if(is_prod_mode){
        let response_update_row_change_approvers: any = yield call<any>(updateItemRequest, {
          listName: approversDependenciesListName,
          bodyArr: [data_update],
          body: { ID: 0 },
        });
      }
    }

    yield put(update_row_change_approvers_success());

  } catch (error) {
    console.log('update_row_change_approvers error', error);
    yield put(update_row_change_approvers_failure(error as string));
  }
}

function* remove_row_change_approvers_worker({ payload }: ReturnType<typeof remove_row_change_approvers>): Generator {
  try {
    console.log('remove_row_change_approvers_worker', payload);

    if(is_prod_mode){
      yield call<any>(deleteItemRequest, {
        listName: approversDependenciesListName,
        ID: payload.item.ID,
      });
    }

    yield call(fetchAndRejectApprovalDocuments, payload.item.Collection.id, payload.item.DocumentType.id);

    yield put(remove_row_change_approvers_success());
  } catch (error) {
    yield put(remove_row_change_approvers_failure(error as string));
  }
}

function* add_row_change_approvers_worker({ payload }: ReturnType<typeof add_row_change_approvers>): Generator {
  try {
    console.log('add_row_change_approvers_worker', payload);

    let approvers_ids = [];
    
    if(payload.item.Approvers && payload.item.Approvers.length > 0){
      approvers_ids = payload.item.Approvers.map((approver: any) => getApproverEmail(approver));
    }

    let data_add = {
      // Title: '',
      DocType: parseInt(payload.item.DocType),
      Collection: parseInt(payload.item.Collection),
      Group: payload.item.Group,
      Order: parseInt(payload.item.Order0),
      NotChange: payload.item.NotChange == '1' ? false : true,
      // Users: payload.item.NotChange == '2' ? approvers_ids : [],
      // DefaultApprovers: payload.item.NotChange == '1' ? approvers_ids : [],
      Users: approvers_ids,
      DefaultApprovers: approvers_ids,
    }

    if(is_prod_mode){
      let response_add_row_change_approvers: any = yield call<any>(addItemRequest, {
        listName: approversDependenciesListName,
        body: data_add
      });
    }

    yield call(fetchAndRejectApprovalDocuments, payload.item.Collection, payload.item.DocType);

    yield put(add_row_change_approvers_success());
  } catch (error) {
    yield put(add_row_change_approvers_failure(error as string));
  }
}

export function* changeApproversWatcher() {
  yield takeLatest(add_row_change_approvers, add_row_change_approvers_worker);
  yield takeLatest(remove_row_change_approvers, remove_row_change_approvers_worker);
  yield takeLatest(update_row_change_approvers, update_row_change_approvers_worker);
  yield takeLatest(get_approvers_documents_by_approvers, get_approvers_documents_by_approvers_worker);
  yield takeLatest(update_approvers_documents_by_approvers, update_approvers_documents_by_approvers_worker);
}